<template>
    <div class="com-codics-hbb-order-system-admin-header-body">
        <MyBreadCrumb :bread-list="breadList" style="padding: unset !important;margin-left: 20px;"></MyBreadCrumb>
        <!-- <div class="com-codics-hbb-order-system-admin-header-icon iconfonts" title="帮助中心" @click="jumpToSc">&#xe86b;
        </div> -->
        <el-drawer custom-class="com-codics-hbb-order-system-admin-header-mess-drawer" title="消息中心"
            :visible.sync="messDrawer" :direction="messDirection" :size="messSize">
            <div class="com-codics-hbb-order-mess-control"
                :style="{ width: messDirection == 'btt' ? '100%' : '450px' }">
                <el-link type="warning"
                    style="text-align: center;padding: 0 20px 0 20px;position: relative;float: left;"
                    :underline="false">查看更多</el-link>
                <el-link type="warning"
                    style="text-align: center;padding: 0 20px 0 20px;position: relative;float: right;"
                    :underline="false">消息设置</el-link>
            </div>
            <div v-infinite-scroll="loadMess" style="height:calc(100% - 50px);overflow:auto;">
                <div class="com-codics-hbb-order-mess-box" v-for="(item, index) in messData" :key="index">
                    <div class="com-codics-hbb-order-mess-card">
                        <div class="com-codics-hbb-order-mess-top-bar">
                            <el-avatar v-show="item.account != null" shape="square" :size="26"
                                style="top: 50%;transform: translateY(-50%);position: relative;float: left;margin-right: 10px;"
                                :src="(item.account == null || item.account.himg == null) ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : item.account.himg"></el-avatar>
                            <div class="com-codics-hbb-order-mess-top-nick">{{ item.account == null ? '系统消息' :
                                item.account.nick }}
                            </div>
                            <el-dropdown
                                style="height: 50px;width: 50px;position: relative;float: right;cursor: pointer;">
                                <div class="com-codics-hbb-order-mess-top-more">
                                    <i class="el-icon-more com-codics-hbb-order-mess-top-more-icon"
                                        style="position: absolute;margin: auto;"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>删除消息</el-dropdown-item>
                                    <el-dropdown-item>查看详情</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                        <div class="com-codics-hbb-order-mess-body" v-html="item.content">
                        </div>
                        <div class="com-codics-hbb-order-mess-top-bar com-codics-hbb-order-mess-bottom-bar">
                            <div class="com-codics-hbb-order-mess-bottom-time">2024-03-12 11:11:11</div>
                            <el-button type="text" class="com-codics-hbb-order-mess-detail">查看详情<i
                                    class="el-icon-arrow-right el-icon--right"></i></el-button>
                        </div>
                    </div>
                </div>
                <div
                    style="height: 50px;width: 100%;position: relative;float: left;line-height: 50px;text-align: center;color: #AAA;font-size: 15px;">
                    没有更多消息了~</div>
            </div>
        </el-drawer>
        <LoginDialog :visible.sync="loginDialog" :lock="true"></LoginDialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import LoginDialog from '@/components/LoginDialog';
import MyBreadCrumb from '@/components/MyBreadCrumb';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            loginDialog: false,
            breadList: [
                {
                    title: '首页',
                    url: '/admin'
                },
                {
                    title: '员工管理',
                    url: '/admin'
                }
            ],
            themeData: ['&#xe89e;  亮色', '&#xe899; 暗黑'],
            themeState: localStorage.getItem('theme') === 'light',
            messDrawer: false,
            messDirection: 'rtl',
            messSize: '20%',
            messData: [
                {
                    account: null,
                    content: '您有新的订单，请及时处理！'
                }
            ]
        }
    },
    mounted() {
        if (this.userInfo == null) {
            this.loginDialog = true;
        }
        this.messDirection = this.isMobileByScreen() ? 'btt' : 'rtl';
        this.messSize = this.isMobileByScreen() ? 'calc(100% - 60px)' : '450px';
    },
    methods: {
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        jumpToSc() {
            if (this.userInfo?.user?.manual != null) {
                this.jumpToWeb(this.userInfo?.user?.manual?.url, '_blank')
            } else if (this.userInfo?.user?.member === 0) {
                this.jumpToWeb('https://fk.waimg.cn/', '_blank')
            }
        },
        jumpToWeb(url, target) {
            window.open(url, target);
        },
        loadMess() {

        },
        isMobileByScreen() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            return isSmallScreen && isTouchDevice;
        },
        changeTheme() {
            this.themeState = !this.themeState;
            const currentTheme = document.documentElement.getAttribute('data-theme');
            const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
            document.documentElement.setAttribute('data-theme', newTheme);
            localStorage.setItem('theme', newTheme);
        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    watch: {
        $route: {
            handler(val, oldVal) {
                this.breadList = [];
                this.$route.matched.forEach((item, index) => {
                    this.breadList.push({
                        title: item.name,
                        url: item.path
                    });
                });
            },
            deep: true,
            immediate: true // 立即触发
        }
    },
    components: {
        MyBreadCrumb,
        LoginDialog
    }
}
</script>

<style>
.com-codics-hbb-order-system-admin-header-body {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    transition: .3s;
    background: var(--sbar-bg-color);
    border-bottom: 1px solid #EBEBEB;
    border-bottom: 1px solid var(--sbar-l-color);
}

.com-codics-hbb-order-system-admin-header-search {
    width: 250px !important;
    position: relative;
    float: right;
    margin-right: 10px;
    margin-top: 9px;
}

.com-codics-hbb-order-system-admin-header-icon {
    height: 100%;
    width: 50px;
    position: relative;
    float: right;
    line-height: 50px;
    text-align: center;
    box-sizing: border-box;
    font-size: 16px;
    cursor: pointer;
    transition: .3s;
    color: #000;
    color: var(--sbar-font-color);
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-system-admin-header-badge {
    position: relative;
    float: right;
}

.com-codics-hbb-order-system-admin-header-badge sup {
    top: 13px !important;
    right: 21px !important;
    font-size: 8px !important;
    height: 13px !important;
    line-height: 13px !important;
    padding: 0 4px !important;
}

.com-codics-hbb-order-system-admin-header-theme-box {
    height: 100%;
    width: fit-content;
    position: relative;
    float: right;
    box-sizing: border-box;
    padding: 12px 10px;
}

.com-codics-hbb-order-system-admin-header-theme-card {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    border-radius: 13px;
    background: #EEE;
    background: var(--tbar-theme-bg-color);
    transition: .3s;
    box-sizing: border-box;
    padding: 2px;
}

.com-codics-hbb-order-system-admin-header-theme-item {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    transition: .3s;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 10px;
    line-height: 22px;
    font-size: 11px;
    color: #000;
    color: var(--tbar-theme-font-color);
    user-select: none;
    -webkit-user-drag: none;
    font-weight: 500;
}

.com-codics-hbb-order-system-admin-header-theme-card::before {
    content: '';
    height: calc(100% - 4px);
    width: calc(50% - 2px);
    position: absolute;
    margin: auto;
    top: 2px;
    left: var(--themeState);
    background: #FFF;
    background: var(--tbar-theme-card-color);
    border-radius: 12px;
    transition: .3s;
}

.com-codics-hbb-order-system-admin-header-mess-drawer {
    background: var(--sbar-bg-color) !important;
}

.com-codics-hbb-order-system-admin-header-mess-drawer header {
    color: var(--sbar-font-color) !important;
}

/* 管理端信息控制栏 */
.com-codics-hbb-order-mess-control {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    line-height: 50px;
}

/* 消息盒子 */
.com-codics-hbb-order-mess-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px 20px;
}

/* 消息盒子卡片 */
.com-codics-hbb-order-mess-card {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #f8f8f8;
}

/* 消息盒子卡片顶栏 */
.com-codics-hbb-order-mess-top-bar {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #EEE;
}

/* 消息盒子顶栏昵称 */
.com-codics-hbb-order-mess-top-nick {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: #333;
}

/* 消息盒子顶栏更多按钮 */
.com-codics-hbb-order-mess-top-more {
    height: 100%;
    width: 50px;
    position: relative;
    float: right;
}

.com-codics-hbb-order-mess-top-more-icon {
    height: fit-content;
    width: fit-content;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

/* 消息盒子消息控件 */
.com-codics-hbb-order-mess-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: #888;
}

/* 消息盒子底栏 */
.com-codics-hbb-order-mess-bottom-bar {
    border-bottom: none;
    border-top: 1px solid #EEE;
}

/* 消息盒子底栏消息时间 */
.com-codics-hbb-order-mess-bottom-time {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 50px;
    text-align: center;
    font-size: 15px;
    color: #333;
}

/* 消息盒子底栏详情按钮 */
.com-codics-hbb-order-mess-detail {
    position: relative;
    float: right;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

.com-codics-hbb-order-system-admin-header-btn {
    height: 100%;
    width: 50px;
    position: relative;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
    transition: .3s;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

@media screen and (max-width: 768px) {
    .com-codics-hbb-order-system-admin-header-51la {
        display: none;
    }
}
</style>